// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"F5-z","refreshPageWarning":"G5-z","redirectMessageText":"H5-z"};